import { computed, ref, Ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { isSmartphone } from '@/dashboard/constants/ui';
import { showNotification } from '@/dashboard/vue/notifications/notification_actions';
import { Draft } from '@/dashboard/types/draft';

export function useDraftCard(draft: Draft) {
  const card: Ref<HTMLDivElement | undefined> = ref(undefined);
  const menu: Ref<{ menu?: HTMLDivElement } | undefined> = ref(undefined);
  const panel: Ref<HTMLDivElement | undefined> = ref(undefined);
  const showMenu: Ref<boolean> = ref(false);

  const link = computed(() => `/${draft.short_link}`);

  function getMenuStyle(): { left?: string; right?: string } {
    if (isSmartphone.value) {
      return {};
    }

    if (!!menu.value?.menu && !!panel.value) {
      const menuBounds = menu.value.menu.getBoundingClientRect();
      const panelBounds = panel.value.getBoundingClientRect();

      if (panelBounds.x + panelBounds.width + menuBounds.width >= window.innerWidth - 10) {
        return {
          right: '50px',
        };
      } else {
        return {
          left: 'calc(100% - 6px)',
        };
      }
    } else {
      return {};
    }
  }

  function copyDraft() {
    showNotification('copy_draft', {
      data: draft.short_link,
      emoji: '👌',
      title: isSmartphone.value ? 'URL copied to clipboard' : 'URL has been successfully copied to clipboard',
    });
  }

  async function copyName() {
    const name = draft.name;
    await navigator.clipboard.writeText(name);
    showNotification('any_type', {
      data: name,
      emoji: '👌',
      title: isSmartphone.value ? 'Name copied to clipboard' : 'Name has been successfully copied to clipboard',
    });
  }

  function showMenuAction(event?: MouseEvent) {
    event?.stopImmediatePropagation();
    showMenu.value = !showMenu.value;
  }

  function closeMenu() {
    if (showMenu.value) {
      showMenu.value = false;
    }
  }

  onClickOutside(card, (event: Event) => (showMenu.value = false));

  return {
    card,
    panel,
    menu,
    showMenu,
    link,
    copyDraft,
    copyName,
    showMenuAction,
    closeMenu,
    getMenuStyle,
  };
}
